import { HttpClient } from '@angular/common/http';

const PROFILE_PICTURE_ENDPOINT = 'https://graph.microsoft.com/v1.0/me/photos/48x48/$value';
export interface ProfilePictureProviderInterface {
  getProfilePicture(): Promise<Blob>;
}

export class ProfilePictureProvider {
  constructor(private httpClient: HttpClient) {}

  async getProfilePicture(): Promise<Blob> {
    /**
     * Important to use http client in order to catch errors
     */
    return this.httpClient
      .get(PROFILE_PICTURE_ENDPOINT, {
        responseType: 'blob'
      })
      .toPromise();
  }
}

function blobToBase64(blob) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = function() {
      resolve(this.result);
    };
    reader.readAsDataURL(blob);
  });
}
function base64ToBlob(base64) {
  if (!fetch) {
    return null;
  }
  return fetch(base64).then(res => res.blob());
}

export class ProfilePictureCacheWrapper {
  static TTL = 18 * 60 * 60 * 1000; // 18 hours local cache for user pictures
  constructor(private profilePictureProvider: ProfilePictureProviderInterface) {}
  async getProfilePicture(accountName: string): Promise<Blob> {
    const accountCacheKey = `PROFILE_CACHE_${accountName}`;
    try {
      const cachedItem = localStorage.getItem(accountCacheKey);
      if (cachedItem != null) {
        const itemValue = JSON.parse(cachedItem);
        if (Date.now() < itemValue[0]) {
          return Promise.resolve(await base64ToBlob(itemValue[1]));
        }
      }
      const profilePicture = await this.profilePictureProvider.getProfilePicture();
      const base64ProfilePicture = await blobToBase64(profilePicture);
      localStorage.setItem(accountCacheKey, JSON.stringify([Date.now() + ProfilePictureCacheWrapper.TTL, base64ProfilePicture]));
      return profilePicture;
    } catch (e) {
      return null;
    }
  }
}
